import { useState, useEffect, useRef } from 'react';

export default function SearchInput({
    value: externalValue = '',
    onSearch,
    placeholder = 'Search...',
    debounce = 400,
}) {
    const [value, setValue] = useState(externalValue);
    const isFirstRender = useRef(true);

    useEffect(() => {
        setValue(externalValue);
    }, [externalValue]);

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }

        const timer = setTimeout(() => {
            onSearch(value);
        }, debounce);

        return () => clearTimeout(timer);
    }, [value]);

    return (
        <div className="search-input">
            <div className="input-group">
                <span className="input-group-text bg-white">
                    <i className="bi bi-search"></i>
                </span>
                <input
                    type="text"
                    className="form-control"
                    placeholder={placeholder}
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                />
                {value && (
                    <button
                        className="btn btn-outline-secondary"
                        type="button"
                        onClick={() => setValue('')}
                    >
                        <i className="bi bi-x"></i>
                    </button>
                )}
            </div>
        </div>
    );
}
